<div class="is-flex is-align-center is-justify-space-between gap-40">
  <app-weather-forecast-icon class="is-flex-shrink-0" [symbol]="today().weather_symbol_day" width="100" height="100"></app-weather-forecast-icon>
  <div class="is-flex is-align-center gap-40 is-flex-shrink-0">
    <div class="is-flex is-align-center gap-24">
      <div class="is-flex is-family-light text-40 text-grey-50">
        <app-text>{{ today().min_temp | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE}}</app-text>
        <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
      </div>
      <div class="is-flex is-family-bold text-40 text-grey-70">
        <app-text>{{ today().max_temp | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE}}</app-text>
        <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
      </div>
    </div>
  </div>

  <div class="info-container is-flex is-flex-grow-1 is-justify-space-between is-align-self-stretch">

    <div class="card is-flex is-column is-justify-center is-align-center gap-8">
      <app-icon class="text-yellow" name="weather-sun"></app-icon>
      <app-text class="text-14 is-family-semiBold text-grey-70">{{ today().sun ?? '--' }} h</app-text>
      <!-- #crowdin -->
      <div class="is-fullwidth">
        <app-text class="ellipsis text-12 is-family-medium text-grey-50">Sunshine duration</app-text>
      </div>
    </div>

    <div class="card is-flex is-column is-justify-center is-align-center gap-8">
      <app-icon class="text-grey-70" name="weather-uv"></app-icon>
      <app-text class="text-14 is-family-semiBold text-grey-70">{{ today().uv }}</app-text>
      <!-- #crowdin -->
      <div class="is-fullwidth">
        <app-text class="ellipsis is-justify-center text-12 is-family-medium text-grey-50">UV Index</app-text>
      </div>
    </div>

    <div class="card is-flex is-column is-justify-center is-align-center gap-8">
      <app-icon class="text-arctic-blue" name="weather-heavy-rain"></app-icon>
      <div class="is-flex text-14 is-family-semiBold text-grey-70">
        <app-text>{{ today().rain | toUserUnit : EnumMeasureTypes.SUM_RAIN | toDisplayValue : EnumMeasureTypes.SUM_RAIN }}</app-text>
        &nbsp;
        <app-text unit [measureType]="EnumMeasureTypes.SUM_RAIN"></app-text>
      </div>
      <div class="is-fullwidth">
        <app-text class="ellipsis is-justify-center text-12 is-family-medium text-grey-50">
          {{ 'common-app.__WIND' | AsyncLang | async }}
        </app-text>
      </div>
    </div>

    <div class="card is-flex is-column is-justify-center is-align-center gap-8">
      <app-icon [style.color]="'#BBDAFF'" name="weather-wind"></app-icon>
      <div class="is-flex text-14 is-family-semiBold text-grey-70">
        <app-text>{{ today().windstrength | toUserUnit : EnumMeasureTypes.WIND_STRENGTH | toDisplayValue : EnumMeasureTypes.WIND_STRENGTH }}</app-text>
        &nbsp;
        <app-text unit [measureType]="EnumMeasureTypes.WIND_STRENGTH"></app-text>
      </div>
      <div class="is-fullwidth">
        <app-text class="ellipsis is-justify-center text-12 is-family-medium text-grey-50">
          {{ 'common-app.__RAIN' | AsyncLang | async }}
        </app-text>
      </div>
    </div>
  </div>
</div>